import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export default function setTitle(moduleId: string, platformCapabilities: Set<string>) {
    if (
        (!platformCapabilities.has('setOverpanelTitle') && moduleId.includes('tectonOverpanel')) ||
        !platformCapabilities.has('setPageTitle')
    ) {
        return;
    }

    return function(title: string): void {
        sendMessage('setTitle', Maybe.just({ title, moduleId }).map(JSON.stringify));
    };
}
